/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
export const ViewConfEnum = {
    GET_CONFIGS: '/configs',
    GET_CONFIG: (module: string, config: string): string => {
        return `/configs/${module}/${config}`;
    }
};
